export function updateCategory(category,defHomebox) {
  return {
    type: '@category/UPDATE',
    payload:  { category, defHomebox },
  };
}
